import Client from '../HttpClient';

const getPolicy = (merchantId) => {
	return Client.get(
		`/gateway/eagle-mgt/api/vs/manage/${merchantId}/merchantPolicy`
	);
};

const postPolicy = (merchantId, data) => {
	return Client.post(
		`/gateway/eagle-mgt/api/vs/manage/${merchantId}/merchantPolicy`,
		data
	);
};

const delPolicy = (merchantId, id) => {
	return Client.del(
		`/gateway/eagle-mgt/api/vs/manage/${merchantId}/merchantPolicy/${id}`
	);
};

const activePolicy = (merchantId, data) => {
	return Client.post(
		`/gateway/eagle-mgt/api/vs/manage/${merchantId}/merchantPolicy/activeOrNo`,
		data
	);
};

export default {
	getPolicy,
	postPolicy,
	delPolicy,
	activePolicy,
};
